import styled from 'styled-components';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { fonts } from '~/src/helpers/font';
import { blockMargin, breakPoints, CSSPropWithBreakpoints, styleWithBreakPoints } from '~/src/components/LandingBlock/styled';

export interface ICallbackBlockStyles {
    [key: string]: CSSPropWithBreakpoints;
}

export const Wrapper = styled.div<{ [key: string]: string }>`
    position: relative;
    width: 100%;
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};
    display: flex;
    padding-top: 100px;
    padding-bottom: 100px;
    min-height: 300px;

    ${p => blockMargin(p)};        
    ${p => styleWithBreakPoints(p, 'Callback')};
`;

export const Grid = styled(GridContainer)`
    display: flex;
    align-items: center;

    @media (max-width: ${breakPoints.sDesktop}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;
export const Col = styled(FlexBoxCol)``;
export const Row = styled(FlexBoxRow)``;

export const BorderWrapper = styled.div`
    width: 100%;
    background: ${COLORS.white};
    border: 1px solid ${COLORS.outlineGrey};
    border-radius: 8px;
    padding: 60px 80px;
    
    @media (max-width: ${breakPoints.sDesktop}) {
        padding: 30px 40px;
    }
`;

export const Title = styled.div`
    margin-bottom: 40px;

    ${p => styleWithBreakPoints(p, 'Callback.Title')};
`;
export const Text = styled.div`
    width: 100%;
    margin-bottom: 15px;
    
    ${p => styleWithBreakPoints(p, 'Callback.SubTitle')};
`;

export const Ol = styled.ol`
    margin-top: 20px;
    padding: 0;
    width: 100%;
    counter-reset: list;
`;

export const Item = styled.li`
    font: ${fonts.S};
    padding-left: 79px;
    position: relative;
    display: flex;
    align-items: center;
    height: 64px;
    list-style-type: none;
    margin-bottom: 10px;
    
    &:before {
        counter-increment: list;
        content: counter(list);
        position:absolute;
        left: 0;
        top: 0;
        width: 64px;
        height: 64px;
        font: ${fonts.H2};
        line-height: 64px;
        text-align: center;
        background-color: rgba(0,0,0,.05);
        border-radius: 100%;
    }
    
    ${p => styleWithBreakPoints(p, 'Callback.Instruction')};
`;

export const Phone = styled(FlexBoxRow)`
    width: 100%;
    font: ${fonts.L};
    color: ${COLORS.black};
    
    ${p => styleWithBreakPoints(p, 'Callback.Phone')};
`;

export const PhoneLabel = styled.div`
    display: flex;
    margin-top: 32px;
    width: 100%;
    font: ${fonts.S};
    justify-content: center;
`;

export const PhoneLink = styled.a`
    display: inline-block;
    justify-content: center;
    margin-top: 16px;
    font: ${fonts.Medium};
    cursor: pointer;
    color: inherit;
`;
